<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { incomeExpenseReportService } from "../../../../services/reportservice/incomeexpensereport.service.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Sale-Detail Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Input,
    Select, 
  },
  data() {
    return {
      title: "Sale Detail Report",
      data: [],
      date: '',
      projects: {},
      summary: {},
      projectName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      user: JSON.parse(localStorage.getItem('user')),

      dataStartDate: '',
      dataEndDate: '',
      dataProjectId: 0,
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    
  },
  methods: {
    
     
    loadingData: function() {
      
      incomeExpenseReportService.getSaleDetail()
        .then(response => {
          this.data = response.data.sale;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
          this.projects = response.data.project;
          this.summary = response.data.summary;
          this.projectName = response.data.project_name;
          
        });
        
    },
    submitSearch: function() {
      let data = '?project_id='+this.dataProjectId+'&start_date='+this.dataStartDate+'&end_date='+this.dataEndDate
      incomeExpenseReportService.getSaleDetail(data)
        .then(response => {
          this.data = response.data.sale;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
          this.projects = response.data.project;
          this.summary = response.data.summary;
          this.projectName = response.data.project_name;

      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    moment: function () {
      return moment();
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },
    totalCount(column_name, type=0){
      let total = 0;
      this.data.map(function(dd){

        if(dd.seller_name && column_name == 'seller_name' && dd.property_status_id == type){
          total++;
        }
        if((dd.agency_name && column_name == 'agency_name') && (dd.agency_name !=  dd.seller_name) && dd.seller_name == null && dd.property_status_id == type){
          total++;
        }
        if(dd.property_status_id == 2 && column_name == 'booking'){
          total++;
        }

        if(dd.property_status_id == 3 && column_name == 'sold'){
          total++;
        }

        if(column_name == 'total_property'){
          total++;
        }
      });

      return total;
      // return this.data.reduce(function (sum, item) {
      //   if(item.seller_name != '')
      //   return sum + item[column_name];
        
      // }, 0)
    }
  },
  computed: {
    totalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + item.sale_price
      }, 0)
    },
    totalDiscount() {
      return this.data.reduce(function (sum, item) {
        let total = 0;
        if(item.discount_type == 1){
          total = sum + (item.sale_price * item.discount / 100);
        }else{
          total = sum + item.discount;
        }
        return total;
      }, 0)
    },
    totalSalePrice() {
      return this.data.reduce(function (sum, item) {
        let total = 0;
        if(item.discount_type == 1){
          total = sum + (item.sale_price - (item.sale_price * item.discount / 100));
        }else{
          total = sum + (item.sale_price - item.discount);
        }
        return total
      }, 0)
    },
    countPropertyUnit(){
       return this.data.reduce(function (count) {
        let total = count +1;
        return total
      }, 0)
    }
    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.sale-detail.text')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="dataStartDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'end_date'"
                  v-model="dataEndDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="35%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 92 66 88 | 086 62 66 89 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class="khb"><u>{{$t('report.sale-detail.text')}}</u></p>
                    <p class="khb"><u>ប្រចាំខែ: {{this.dateFormat(date.start_date)}} - {{this.dateFormat(date.end_date)}}</u></p>
                    <p class="khb"><u>គម្រោង: {{this.projectName}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th>{{$t('general.number')}}</th>
                  <th>{{$t('report.income_expense.date')}}</th>
                  <!-- <th style="width:7em;">{{$t('setting.configuration.contract-template.type')}}</th>
                  <th style="width:7em;">{{$t('customer.code')}}</th> -->
                  <th style="width:7em;">{{$t('customer.text')}}</th>
                  <th style="width:7em;">{{$t('customer.phone-no')}}</th>
                  <th style="width:7em;">{{$t('general.staff')}}</th>
                  <th style="width:7em;">{{$t('general.agency-seller')}}</th>
                  <th>{{$t('property.text')}}</th>
                  <th>{{$t('general.unit_price')}}</th>
                  <th>{{$t('sale.discount')}}</th>
                  <th>{{$t('sale.sale-price')}}</th>
                  <!-- <th>{{$t('commission.text')}}</th> -->
                  <th>{{$t('booking.notation')}}</th>
                  <th>{{$t('report.sale-detail.user')}}</th>
                  <th style="width:5em;">{{$t('commission.status')}}</th>
                </tr>
               
              
              <tbody>
                <tr v-for="(list, index) in data" :key="index" >

                  <td>{{index + 1}}</td>
                  <!-- <td>{{list.project_code}}</td> -->
                  <td>{{dateFormat(list.date)}}</td>
                  <!-- <td>{{list.loan_type}}</td>
                  <td>{{list.code}}</td> -->
                  <td>{{list.customer_name}}</td>
                  <td>{{`${list.phone_no_1}` + (list.phone_no_2 !=null? ` / ${list.phone_no_2}` : '')}} </td>
                  <td>{{list.seller_name}}</td>
                  <td>{{ (list.agency_type == 2 || list.agency_type == 3) ? list.agency_name : '' }}</td>
                  <td>{{list.property_code}}</td>
                  <td>{{formatCurrency(list.sale_price)}}</td>
                  <td>{{formatCurrency(discountPrice(list.sale_price, list.discount, list.discount_type))}}</td>
                  <td>{{formatCurrency(list.sale_price - discountPrice(list.sale_price, list.discount, list.discount_type))}}</td>
                  <!-- <td>{{list.commission}}</td> -->
                  <td>{{list.notation}}</td>
                  <td>{{list.user_name}}</td>
                  <td>{{list.property_status_name}}</td>
                </tr>
              </tbody>
                <tr v-if="data" class="tfoot">
                  <td colspan="6" class="border text-end pe-2">{{$t('stock-owner.total')}}</td>
                  <td class="border">{{(countPropertyUnit)}}</td>
                  <td class="border">{{formatCurrency(totalPrice)}}</td>
                  <td class="border">{{formatCurrency(totalDiscount)}}</td>
                  <td >{{formatCurrency(totalSalePrice)}}</td>
                  <td colspan="4" class="border"></td>
                </tr>
            </table>
            <br>
            
            <div class="row">
              <div class="col">
                <table class="content-general h8 project-sumary-table report-table" width="85%">
                
                  <tr class="thead">
                    <th>{{$t('report.summary')}}</th>
                    <th width="50px">{{$t('general.amount')}}</th>
                    <th>{{$t('report.sale-detail.sold')}}</th>
                    <th>{{$t('report.sale-detail.staff')}}</th>
                    <th>{{$t('report.sale-detail.agency')}}</th>
                    <th>{{$t('report.sale-detail.available')}}</th>
                  </tr>
                <tbody>
                  <tr class="table-head-1">
                    <td style="text-align:left;">{{$t('general.total-unit-amount')}}</td>
                    <td>{{summary.total_unit}}</td>
                    <td>{{summary.total_all_sale}}</td>
                    <td>{{summary.total_all_sale_seller}}</td>
                    <td>{{summary.total_all_sale_agency}}</td>
                    <td>{{summary.available}}</td>
                  </tr>
                  <tr>
                    <td style="text-align:left;">{{$t('general.monthly-sale-unit')}}</td>
                    <td></td>
                    <td>{{summary.total_sale}}</td>
                    <td>{{summary.total_sale_seller}}</td>
                    <td>{{summary.total_sale_agency}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="text-align:left;">{{$t('general.monthly-booking-unit')}}</td>
                    <td></td>
                    <td>{{summary.total_booking}}</td>
                    <td>{{summary.total_booking}}</td>
                    <td>0</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="text-align:left;">{{$t('general.monthly-cancel-unit')}}</td>
                    <td colspan="5" style="text-align:center;">{{summary.total_cancel}}</td>
                  </tr>
                </tbody>
                  <tr class="tfoot">
                    <td colspan="2" style="text-align:center;">{{$t('general.total')}}</td>
                    <td>{{summary.total_sale + summary.total_booking}}</td>
                    <td>{{summary.total_sale_seller + summary.total_booking}}</td>
                    <td>{{summary.total_sale_agency}}</td>
                    <td></td>
                  </tr>
                </table>
              </div>
              <div class="col-2"></div>
              <div class="col-2 report-table">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <br><br>

                  <p></p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col-2 report-table">
                <center>
                  <p class="align-right">{{$t('report.income_expense.date')}} {{this.moment().format('DD/MM/YYYY')}}<br>អ្នកធ្វើរបាយការណ៍</p>
                    <br><br>

                    <p>{{this.user.name}}</p>
                  </center>
              </div>
            </div>
            <div class="row mt-3 report-table">
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                  <br><br>

                  <p>លី ប៊ុនហ៊ាង</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកហិរញ្ញវត្ថុ</p>
                  <br><br>

                  <p>លឹម ទ្រី</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកបច្ចេកទេស</p>
                  <br><br>

                  <p>សាយនី យូស៊ន់</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              
              <div class="col">
               
              </div>
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>